import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.598 13.104L20.525 9.8l-2.128-6.547a.366.366 0 00-.695 0L15.574 9.8H8.51L6.382 3.253a.366.366 0 00-.695 0L3.559 9.8l-1.073 3.304a.731.731 0 00.265.818l9.291 6.75 9.29-6.75a.731.731 0 00.266-.818"
    />
  </svg>
);
